import { render } from "./MixedField.vue?vue&type=template&id=2bdf38a6"
import script from "./MixedField.vue?vue&type=script&lang=js"
export * from "./MixedField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__